export interface VehicleOrderRedirectProps {
  type: VehicleOrderRedirectTypes;
}

export enum VehicleOrderRedirectTypes {
  Link = 'link',
  InfoBox = 'infoBox'
}
